module.exports = __webpack_public_path__ + "static/media/AdkissonMorgan_Resume.6f6b593f.pdf";